import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { TableWithCopy } from "../TableWithCopy/TableWithCopy";
import "./app-markdown.scss";

const markdownComponents = { table: TableWithCopy };

export const AppMarkdown = ({ children, className = "" }) => (
  <div className={`md-body ${className}`.trim()}>
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={markdownComponents}
    >
      {children}
    </ReactMarkdown>
  </div>
);

AppMarkdown.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

export default AppMarkdown;
